import { BrowserRouter, Link, Navigate, NavLink, Route, Routes } from 'react-router-dom';
import { Anchor, Box, Grommet, Header, Main, Text } from 'grommet';

import Dashboard from './pages/Dashboard';
import DocsIndex from './pages/DocsIndex';
import DocPage from './pages/DocPage';
import History from './pages/History';
import NotFound from './pages/NotFound';
import Pals from './pages/Pals';
import { navDocs } from './docs/manifest';
import { theme } from './theme';

// Grommet's Anchor doesn't expose active state, so the underline is driven by
// NavLink's own isActive callback.
const navStyle = ({ isActive }) => ({
  color: 'inherit',
  textDecoration: isActive ? 'underline' : 'none',
  textUnderlineOffset: '4px',
});

const AppHeader = () => (
  <Header background="brand" pad="small" gap="medium">
    <Anchor as={Link} to="/" color="light-1">
      <Text size="large" weight="bold" color="light-1">Fantasy Pals</Text>
    </Anchor>
    <Box as="nav" direction="row" gap="medium">
      <Text color="light-1"><NavLink to="/" end style={navStyle}>Home</NavLink></Text>
      <Text color="light-1"><NavLink to="/history" end style={navStyle}>History</NavLink></Text>
      <Text color="light-1"><NavLink to="/docs" end style={navStyle}>Docs</NavLink></Text>
      {navDocs().map((doc) => (
        <Text key={doc.slug} color="light-1">
          <NavLink to={`/docs/${doc.slug}`} style={navStyle}>{doc.nav}</NavLink>
        </Text>
      ))}
    </Box>
  </Header>
);

function App() {
  return (
    <Grommet theme={theme} full>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Main overflow={{ vertical: 'auto' }}>
          <AppHeader />
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/history" element={<History />} />
            <Route path="/pals" element={<Pals />} />
            <Route path="/docs" element={<DocsIndex />} />
            <Route path="/docs/:slug" element={<DocPage />} />
            {/* Header items are worth a guessable URL of their own. */}
            {navDocs().map((doc) => (
              <Route
                key={doc.slug}
                path={`/${doc.slug}`}
                element={<Navigate to={`/docs/${doc.slug}`} replace />}
              />
            ))}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Main>
      </BrowserRouter>
    </Grommet>
  );
}

export default App;
